module.exports = __webpack_public_path__ + "static/media/server_error.45bc42dc.png";